import type { UntitledIconData } from '../../UntitledIconData'

export const ulChevronLeft: UntitledIconData = {
  prefix: 'ul',
  name: 'chevron-left',
  paths: [
    {
      shape: 'M15 18L9 12L15 6',
    },
  ],
}
